import { render, staticRenderFns } from "./SalesTab.vue?vue&type=template&id=9343945a"
import script from "./SalesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports